import React from 'react';

import { Button } from 'react-bootstrap';
import DataTableX from '../../components/datatable/DataTableX';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import FileDownload from 'js-file-download';
import { Buffer } from "buffer";
import * as RestService from '../../services/eisRest';
import moment from 'moment';
import 'moment-timezone';




const FileDatatable = (props) => {

   const [t] = useTranslation();      
   const tableName = t('file.label.files');


  

   const clickHandler = (row) => {
      // console.log('clicked on: '+row.target.id);
       // let name = row.target.name;
    
       RestService.callAnyApi('file/getFile?id='+row.target.id, null)
      // .then((data) => {
      //  RestService.getFile(row.target.id)
        .then((data) => {                                     
                try{           
                    let fileBytes = Buffer.from(data.fileBody, "base64");      
                    FileDownload(fileBytes, data.name);                
                  
                }catch(error){
                    console.error();
                }
               
        })
        .catch((error) => {               
            toast.error(
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                    'Failed'
            );
        });
    
   
   }

   const columns = [       
            { name: "Id", data: "id", selector: "id", omit: true},
            { name: t('general.label.name'), data: "name", sortable: true, selector: "name"},    		
            { name: t('user.label.user'), data: "userLogin",  sortable: true,  selector: "userLogin"},
            { name: t('general.label.timestamp'), data: "timestamp", sortable: true,  selector: "timestamp", format:(row) => {
               return moment(row.timestamp).format('DD.MM.YYYY H:mm');
              //console.log(row);
            }},
            { name: t('general.label.description'), data: "description", sortable: true,  selector: "description"},    		
            {  cell:(row) => <Button onClick={clickHandler} id={row.id} name={row.name} >{t('general.button.show')}</Button>,
               ignoreRowClick: true,
               allowOverflow: true,
               button: true
            }
            		
        ];        


        
    const columnsData = [       
        { name: "Id", data: "id", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('general.label.name'), data: "name",  orderable: true, searchable: true, search: {value: '',regex: false}},    		
        { name: t('user.label.user'), data: "userLogin", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('general.label.timestamp'), data: "timestamp", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('general.label.description'), data: "description", orderable: true,  searchable: true, search: {value: '',regex: false}},    		
        { name: t('general.button.show'), data: "",  orderable: false,  searchable: false, search: {value: '',regex: false}}        
    ];        
    const url = RestService.getBaseURL()+"file/getFileList?entityId="+props.entityId;  
    const urlExcel = "";          
 

    const handleCallback  = (id) => {
            props.parentCallback(id);                   
    };
  
       
        return (          
            <DataTableX
                url={url}  
                urlExcel={urlExcel}  
                tableName={tableName}
                columns={columns}   
                columnsData={columnsData}
                parentCallback={handleCallback}
                modalShow={props.modalShow}
                exportShow={false}
            />                    
        );
   

 
};


export default FileDatatable;

